import { SocialMediaList } from './socialMediaList';
import SocialMediaLogo from './SocialMediaLogo';

import s from './SocialMedia.module.scss';

const SocialMediaLogos = () => (
  <div className={s.logosList}>
    {SocialMediaList.map(({ id, logo, url, alt }) => (
      <SocialMediaLogo key={id} logo={logo} url={url} alt={alt} />
    ))}
  </div>
);

export default SocialMediaLogos;
